/* eslint-disable react/jsx-no-duplicate-props */
import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(() => ({
    fieldInput: {
        border: '0px !important',
    },
}));

const CustomTextField = (props) => {
    const {
        variant = 'standard',
        InputProps,
        inputProps,
        disabled,
        ...other
    } = props;
    const classes = useStyles();

    return (
        <TextField
            disabled={disabled}
            variant={variant}
            InputProps={{
                ...InputProps,
                autoComplete: 'no-autocomplete',
                className: classnames(InputProps?.className || {}, classes.fieldInput),
            }}
            inputProps={{
                ...inputProps,
                autoComplete: 'no-autocomplete',
            }}
            // onFocus={(e) => {
            //     e.target.setAttribute('autocomplete', 'off');
            //     e.target.setAttribute('autocorrect', 'false');
            //     e.target.setAttribute('aria-autocomplete', 'both');
            //     e.target.setAttribute('aria-haspopup', 'false');
            //     e.target.setAttribute('spellcheck', 'off');
            //     e.target.setAttribute('autocapitalize', 'off');
            //     e.target.setAttribute('autofocus', '');
            //     e.target.setAttribute('role', 'combobox');
            // }}
            {...other}
        />
    );
};

export default CustomTextField;
